var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    rx: 256,
    fill: "#FF0550"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262 737.512V411.81C262 409.967 262.979 408.262 264.571 407.334L333.05 367.388C349.081 358.036 357.096 353.36 363.12 356.82C369.143 360.28 369.143 369.559 369.143 388.118V648.226C369.143 659.54 369.143 665.197 372.658 668.711C376.172 672.226 381.829 672.226 393.143 672.226H738C749.314 672.226 754.971 672.226 758.485 675.741C762 679.256 762 684.913 762 696.226V737.512C762 748.826 762 754.482 758.485 757.997C754.971 761.512 749.314 761.512 738 761.512H286C274.686 761.512 269.029 761.512 265.515 757.997C262 754.482 262 748.826 262 737.512Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M738 617.167H458.619C447.305 617.167 441.648 617.167 438.134 613.652C434.619 610.137 434.619 604.48 434.619 593.167V322.897C434.619 316.177 434.619 312.817 436.21 310.043C437.801 307.27 440.701 305.574 446.502 302.181L501.351 270.099C507.271 266.637 510.23 264.905 513.487 264.908C516.743 264.91 519.7 266.646 525.615 270.116L750.147 401.878C755.934 405.273 758.827 406.971 760.413 409.742C762 412.512 762 415.867 762 422.577V593.167C762 604.48 762 610.137 758.485 613.652C754.971 617.167 749.314 617.167 738 617.167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.70349490fe61f6b70ad8a13321c8ca0e.svg";
export { ForwardRef as ReactComponent };